/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  DialogFooter,
  // DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
// import { Switch } from "@/components/ui/switch";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
// import { RetailerListInput } from "../user-input/retailer-list-input";
import {
  ArrayInput,
  MultiSelectWithSearch,
  SelectWithSearch,
} from "@/components/form-input";
import { RequiredInput } from "@/components/shared/required-input";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyData: any;
  retailerList: any[];
  sncErpUomList: string[];
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  retailerList,
  sncErpUomList,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  const sncErpUomListArr = sncErpUomList.map((item) => ({
    value: item,
    label: item,
  }));

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="uom"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Po Uom
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input
                    // disabled={formData ? true : false}
                    placeholder="Uom"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="po_uom_qty"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Po Uom Qty</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="Po Uom Qty"
                    value={"" + field.value}
                    onChange={(e) => field.onChange(+e.target.value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="erp_uom"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Erp Uom
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <SelectWithSearch
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Select Uom"
                    options={sncErpUomListArr}
                    value={field.value}
                    onChange={field.onChange}
                    // onBlur={field.onBlur}
                  />
                  {/* <Input placeholder="Erp uom" {...field} /> */}
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="conversion_rate"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Conversion Rate</FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    placeholder="Conversion Rate"
                    value={"" + field.value}
                    onChange={(e) => field.onChange(+e.target.value)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="retailer_id"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Retailer Name
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <MultiSelectWithSearch
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                    placeholder="Select Retailers"
                    options={retailerList}
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    noLimit={true}
                  />
                  {/* <SelectWithSearch
                    placeholder="Retailer Name"
                    value={field.value}
                    onChange={field.onChange}
                    options={retailerList}
                    bindLabel="retailer_name"
                    bindValue="retailer_id"
                  /> */}
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="sku_code"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Sku Code </FormLabel>
                {/* <pre>{JSON.stringify(field.value)}</pre> */}
                <FormControl>
                  <ArrayInput
                    placeholder="Sku Code"
                    value={field.value}
                    onChange={field.onChange}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="decimal_places"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Qty decimal places </FormLabel>
                {/* <pre>{JSON.stringify(field.value)}</pre> */}
                <FormControl>
                  <Input
                    type={"number"}
                    className="break-all"
                    placeholder="Qty decimal places"
                    value={field.value}
                    onChange={field.onChange}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[160px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[160px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
